module.exports = __webpack_public_path__ + "img/spago.a4647ac6.jpg";